import { setSessionToken } from './api.js';
import type { AuthData } from './auth-client.js';
import { localAcceptanceEnabled } from './local-acceptance-guard.js';

const storageKey = 'ponchik:local-acceptance-session';

export function persistLocalAcceptanceSession(
  result: AuthData,
  enabled = localAcceptanceEnabled(),
): void {
  if (!enabled || typeof window === 'undefined') return;
  window.sessionStorage.setItem(
    storageKey,
    JSON.stringify({ sessionToken: result.sessionToken, user: result.user }),
  );
}

export function restoreLocalAcceptanceSession(
  enabled = localAcceptanceEnabled(),
): Pick<AuthData, 'sessionToken' | 'user'> | null {
  if (!enabled || typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(storageKey);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<AuthData>;
    if (
      typeof value.sessionToken !== 'string' ||
      !value.user ||
      typeof value.user.id !== 'string' ||
      typeof value.user.state !== 'string'
    )
      throw new Error('INVALID_LOCAL_SESSION');
    setSessionToken(value.sessionToken);
    return { sessionToken: value.sessionToken, user: value.user };
  } catch {
    window.sessionStorage.removeItem(storageKey);
    return null;
  }
}

export function clearLocalAcceptanceSession(enabled = localAcceptanceEnabled()): void {
  if (!enabled || typeof window === 'undefined') return;
  window.sessionStorage.removeItem(storageKey);
}
